//Props Validations
import PropTypes from "prop-types";

import { components } from "react-select";
import Avatar from "@mui/material/Avatar";

import { getNameLetter, stringToColor } from "../../../utils/driverAnalysisUtils";

const CustomOption = (props) => {
    return (
        <components.Option
            {...props}
            isDisabled={props.isDisabled}
        >
            <div
                style={{
                    display: "flex",
                    margin: "2px 0px",
                    alignContent: "center",
                }}
            >
                <Avatar
                    // key={i}
                    sx={{
                        bgcolor: stringToColor(props.data.label),

                        width: 18,
                        height: 18,
                        fontSize: 7,
                        // zIndex: i + 1,
                    }}
                >
                    {getNameLetter(props.data.label)}
                </Avatar>
                <span
                    style={{
                        fontSize: "12px",
                        marginLeft: "5px",
                    }}
                >
                    {props.data.label}
                </span>
            </div>
        </components.Option>
    );
};

CustomOption.propTypes = {
    props: PropTypes.object,
    data: PropTypes.object,
    isDisabled: PropTypes.bool,
};

export default CustomOption;
